export default function () {
  $(document).on('click', '[data-print-page]', (e) => {
    e.preventDefault();
    window.print();
  });
}
